module.exports = __webpack_public_path__ + "static/media/report-calender.e48db7ae.svg";